import { Product } from '@commerce/types'
import { EVENT_DEBUG, eventLog, infoLog } from './general'

declare global {
  interface Window {
    dataLayer: any
  }
}

type PinterestLineItem = {
  product_id: string
  product_variant: number | string
  product_variant_id: number | string
  product_price: number | string
  product_quantity: number
  currency: string
}

export const addToCartEvent = (product: Product.Product) => {
  if (EVENT_DEBUG && !window?.dataLayer) {
    infoLog('Add To Cart: No Data Layer found.')
  }

  if (window?.dataLayer) {
    const detail = {
      event: 'ecommerce',
      ecommerceEvent: 'Add To Cart',
      ecommerceEventLabel: 1,
      google_tag_params: {
        ecomm_pagetype: 'cart',
        ecomm_prodid: product?.id,
        // TODO: ecomm_category: product?.categories?.map((c: any) => c.name), // array of all product categories
        ecomm_totalvalue: product.price.value,
      },
      ecommerce: {
        currencyCode: product.price?.currencyCode,
        add: {
          products: {
            name: product?.name,
            id: product?.id,
            price: product.price?.value,
            quantity: 1,
          },
        },
      },
    }
    window?.dataLayer?.push(detail)
    if (EVENT_DEBUG)
      eventLog(`Add To Cart 'gtm.ecommerce.AddToCart (custom)`, { detail })
  }
}

export const pinterestAddToCartEvent = (lineItems: PinterestLineItem[]) => {
  if (EVENT_DEBUG && !window?.dataLayer) {
    infoLog('Add To Cart: No Data Layer found.')
  }
  if (window?.dataLayer) {
    const normalizeGid = (gid: string | number): string | number => {
      if (typeof gid === 'string') {
        const match = gid.match(/(\d+)$/)
        return match ? match[1] : gid
      }
      return gid
    }
    const sanitizedLineItems = lineItems.map((item) => ({
      ...item,
      product_id: normalizeGid(item.product_id),
      product_variant_id: normalizeGid(item.product_variant_id),
    }))
    const detail = {
      event: 'addToCart',
      line_items: sanitizedLineItems
    }
    window?.dataLayer?.push(detail)
    if (EVENT_DEBUG)
      eventLog(`Add To Cart 'Pinterest Tag AddToCart (custom)`, { detail })
  }
}